<template>
  <h1 className="sr-only">Antecipação de FGTS</h1>
  <div class="bg-[#1E1E1E] flex flex-col w-full items-center ">
    <div
      class="flex flex-col w-full gap-[21px] xl:w-[1280px] lg:flex-row lg:px-[102px] lg:gap-[4px] items-center lg:justify-between xl:px-0">
      <div
        class="flex flex-col w-full items-center pt-[64px] px-[41px] gap-[15px] lg:py-0 lg:px-0 lg:items-start lg:max-w-[410px] lg:min-w-[363px]">
        <span class="yellow text-[20px] leading-[115%] lg:border yellow-border px-[29px] py-[5.5px] rounded-full">
          Conte com a Vip
        </span>

        <h2 class="white heading-45 text-center lg:text-left">
          Crédito através da antecipação do seu FGTS
        </h2>

        <p class="!white leading-[115%] text-20 lg:text-left">
          Antecipe até 5 anos do seu Saque Aniversário na Vip com agilidade e segurança.
        </p>
        <LinkButton customClass="!py-[12.5px] !px-[25px] !w-auto !text-[20px]" :url="whatsappUrl"
          label="Simular crédito" />
      </div>

      <div class="flex px-[19px] w-full lg:min-w-[457px] lg:max-w-[696px]">
        <img class="object-cover w-full" src="/img/banner.webp" alt="Banner" />
      </div>
    </div>
  </div>
</template>
<script>
import LinkButton from "./LinkButton.vue";
import { useWhatsappUrl } from "@/composables/useWhatsappUrl";
export default {
  name: "TBanner",
  components: {
    LinkButton,
  },
  setup() {
    const { whatsappUrl } = useWhatsappUrl('Olá, gostaria de simular minha antecipação do FGTS.')
    return { whatsappUrl }
  },
};
</script>
